import React from "react";
import IframePage from "./IframePage";
import "../../../css/BoletinOficial/ordenanza.css";

const Ordenanza = () => (
  <IframePage
    title="ORDENANZAS"
    description="Un gobierno abierto y transparente que pone a disposición de los ciudadanos información relevante para promover mayor participación y cercanía."
    iframeUrl="https://ciudaddeoliva.gov.ar/boletin-oficial/ordenanzas"
    classPrefix="ordenanza"
  />
);

export default Ordenanza;